import { DangerAlert, SuccessAlert } from "~/pages/messages/AlertMessages";

type AlertsProps = {
  showSuccess: boolean;
  showError: boolean;
  successMessage: string;
  errorMessage: string;
  onCloseSucessDialog?: () => void;
  onCloseErrorDialog?: () => void;
  title?: string; 
  enabledSuccess?: boolean; 
  enabledError?: boolean;             
};

export const Alerts = ({
  showSuccess,
  showError,
  successMessage,
  errorMessage,
  onCloseSucessDialog,
  onCloseErrorDialog,
  title,
  enabledSuccess,
  enabledError
}: AlertsProps) => {
  return (
    <>
      {showSuccess && (
        <SuccessAlert title={title || "Success"} message={successMessage} onClose={onCloseSucessDialog} enabled={enabledSuccess} />
      )}

      {showError && (
        <DangerAlert title={title || "Error"}    message={errorMessage} onClose={onCloseErrorDialog} enabled={enabledError}   />
      )}
    </>
  );
};